// Cards marked with `.js-select-card-on-click` toggle their inner checkbox when
// clicked anywhere except on a form input.
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-select-card-on-click").forEach((card) => {
    const checkbox = card.querySelector("input[type=checkbox]");
    if (!checkbox) return;

    card.addEventListener("click", (e) => {
      if (e.target.closest("input, label")) return;
      checkbox.click();
    });
  });
});
